// extracted by mini-css-extract-plugin
export default {"host":"style_host__wR7NE","tabs":"style_tabs__unOp1"};